import type { Aisle, NutriScore } from "@/types/menu";

export const AISLE_LABELS: Record<
  Aisle,
  { fr: string; emoji: string; order: number }
> = {
  produce: { fr: "Marché · Primeur", emoji: "🥬", order: 1 },
  butcher: { fr: "Boucherie", emoji: "🥩", order: 2 },
  fresh: { fr: "Frais", emoji: "🐟", order: 3 },
  dairy: { fr: "Crémerie", emoji: "🧀", order: 4 },
  pantry: { fr: "Épicerie", emoji: "🌾", order: 5 },
  bakery: { fr: "Boulangerie", emoji: "🥖", order: 6 },
  frozen: { fr: "Surgelés", emoji: "❄️", order: 7 },
  drinks: { fr: "Boissons", emoji: "🍷", order: 8 },
  other: { fr: "Autre", emoji: "🛒", order: 99 },
};

export const DAY_LABELS_SHORT = [
  "Dim",
  "Lun",
  "Mar",
  "Mer",
  "Jeu",
  "Ven",
  "Sam",
] as const;

export const MONTH_LABELS_FR = [
  "janvier",
  "février",
  "mars",
  "avril",
  "mai",
  "juin",
  "juillet",
  "août",
  "septembre",
  "octobre",
  "novembre",
  "décembre",
] as const;

export function parseISODate(iso: string): Date {
  // Treat as local-noon to dodge DST / TZ surprises.
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d, 12, 0, 0);
}

export function formatDayLong(iso: string): string {
  const d = parseISODate(iso);
  return `${DAY_LABELS_SHORT[d.getDay()]} ${d.getDate()} ${MONTH_LABELS_FR[d.getMonth()]}`;
}

export function formatDayShort(iso: string): string {
  return DAY_LABELS_SHORT[parseISODate(iso).getDay()];
}

export function formatWeekRange(start: string, days: number): string {
  const a = parseISODate(start);
  const b = new Date(a);
  b.setDate(a.getDate() + days - 1);
  const month =
    a.getMonth() === b.getMonth()
      ? MONTH_LABELS_FR[a.getMonth()]
      : `${MONTH_LABELS_FR[a.getMonth()]} – ${MONTH_LABELS_FR[b.getMonth()]}`;
  return `du ${a.getDate()} au ${b.getDate()} ${month}`;
}

export function formatPrice(eur: number): string {
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 2,
  }).format(eur);
}

export function nutriColor(score: NutriScore | null): string {
  switch (score) {
    case "A":
    case "B":
      return "bg-accent";
    case "C":
      return "bg-accent-dim";
    case "D":
    case "E":
      return "bg-destructive";
    default:
      return "bg-ink-30";
  }
}
